import React, { Suspense } from 'react';

const Component = React.lazy(() => import('../components/file-upload'));

export default function (dependencies) {
  const html = (props) => {
    const componentProps = { ...props, ...dependencies };
    return (
      <Suspense fallback={<span>Loading...</span>}>
        <Component {...componentProps}></Component>
      </Suspense>
    );
  };
  return {
    html,
  };
}
